let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ly14Q")).then(() => parcelRequire('bMF5U'));